let sdkLoadingPromise = null;

export function loadWecomSdk() {
  if (window.ww) {
    return Promise.resolve(window.ww);
  }
  if (sdkLoadingPromise) {
    return sdkLoadingPromise;
  }

  sdkLoadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//wwcdn.weixin.qq.com/node/open/js/wecom-jssdk-2.0.2.js';
    script.onload = () => resolve(window.ww);
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return sdkLoadingPromise;
}

export function registerWecom({ corpId, agentId, getConfigSignature, getAgentConfigSignature }) {
  return window.ww.register({
    corpId,
    agentId,
    jsApiList: ['getCurExternalContact', 'getContext', 'sendChatMessage'],
    getAgentConfigSignature,
    ...(getConfigSignature ? { getConfigSignature } : {}),
  });
}

export function getWecomEntry() {
  return new Promise((resolve, reject) => {
    window.ww.getContext({
      success: res => resolve((res && res.entry) || ''),
      fail: reject,
    });
  });
}

export function getCurrentExternalContact() {
  return new Promise((resolve, reject) => {
    window.ww.getCurExternalContact({
      success: res => resolve((res && res.userId) || ''),
      fail: reject,
    });
  });
}

export function sendTextToCurrentChat(content) {
  return new Promise((resolve, reject) => {
    const sender = window.ww && typeof window.ww.sendChatMessage === 'function'
      ? window.ww
      : window.wx && window.wx.qy && typeof window.wx.qy.sendChatMessage === 'function'
        ? window.wx.qy
        : null;

    if (!sender) {
      reject(new Error('当前环境不支持发送消息'));
      return;
    }

    sender.sendChatMessage({
      msgtype: 'text',
      text: { content },
      success: resolve,
      fail: reject,
    });
  });
}
